import { render } from "./widgetGauge.vue?vue&type=template&id=594ac2ad&scoped=true"
import script from "./widgetGauge.vue?vue&type=script&lang=js"
export * from "./widgetGauge.vue?vue&type=script&lang=js"

import "./widgetGauge.vue?vue&type=style&index=0&id=594ac2ad&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594ac2ad"]])

export default __exports__